export const LOCAL_STORAGE_KEY = "SUNDAESWAP_EXCHANGE_LOCAL_CACHE";
export const LOCAL_PENDING_ORDERS_SLUG = "SUNDAESWAP_EXCHANGE_PENDING_ORDERS";
export const LOCAL_CANCELLED_ORDERS_SLUG = "SUNDAESWAP_EXCHANGE_CANCELLED_ORDERS";
export const LOCAL_STORAGE_FIRST_VISIT_KEY = "SUNDAESWAP_EXCHANGE_FIRST_VISIT";
export const LOCAL_STORAGE_NEWS_READ_KEY = "SUNDAESWAP_EXCHANGE_NEWS_READ_KEY";
export const LOCAL_STORAGE_PENDING_YF_TRANSACTIONS = "SUNDAESWAP_EXCHANGE_PENDING_YF_TRANSACTIONS";
